import { useMemo } from 'react'
import { useQuery } from '@tanstack/react-query'
import { teacherSettingsApi } from '@/services/api/teacher'
import type { SubstitutionRequestConfig, TeacherSettingsResponse } from '@/types/teacher-request'

export type RequestConfigWithPending = SubstitutionRequestConfig & {
  current_pending_requests?: number
}

export function useTeacherRequestConfig() {
  const {
    data: mySettings,
    isLoading: requestConfigLoading,
    error: requestConfigError,
    refetch: refetchMySettings,
  } = useQuery<TeacherSettingsResponse>({
    queryKey: ['my-settings'],
    queryFn: () => teacherSettingsApi.getMySettings() as Promise<TeacherSettingsResponse>,
    staleTime: 30 * 1000,
    refetchOnWindowFocus: true,
    refetchOnMount: true,
    retry: 1,
  })

  const requestConfig = useMemo(() => {
    if (!mySettings) return undefined
    return {
      ...mySettings.effective_config,
      current_pending_requests: mySettings.effective_config.current_pending_requests,
    } as unknown as RequestConfigWithPending
  }, [mySettings])

  return {
    mySettings,
    requestConfig,
    requestConfigLoading,
    requestConfigError,
    refetchMySettings,
  }
}
